module.exports = __webpack_public_path__ + "static/media/3.456e9cd1.jpg";